import config from "@/config"
import http from "@/utils/request"
export default {
	GetOrgClearingInfo: {
	    url: `${config.API_URL}/CiticOrgClearing/GetOrgClearingInfo`,
	    name: "根据机构编码获取机构清分信息",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	GetOrgClearingPriceInfo: {
	    url: `${config.API_URL}/CiticOrgClearing/GetOrgClearingPriceInfo`,
	    name: "根据机构编码获取机构清分信息",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	SaveOrgClearingPriceInfo: {
	    url: `${config.API_URL}/CiticOrgClearing/SaveOrgClearingPriceInfo`,
	    name: "根据机构编码获取机构清分信息",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	SaveOrgClearingInfo: {
	    url: `${config.API_URL}/CiticOrgClearing/SaveOrgClearingInfo`,
	    name: "保存机构清分信息",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	CiticClearing: {
	    url: `${config.API_URL}/CiticOrgClearing/CiticClearing`,
	    name: "保存机构清分信息",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	CiticClearingRefund: {
	    url: `${config.API_URL}/CiticOrgClearing/CiticClearingRefund`,
	    name: "保存机构清分信息",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
}
